import { createApi } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const myOrdersApi = createApi({
  reducerPath: reducerPaths.myOrdersApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getMyOrdersVehicles: builder.query({
      query: () => {
        return {
          url: `/myGarage/Dealer/myOrders`,
          method: "GET"
        }
      }
    }),
    getSellerMyOrdersVehicles: builder.query({
      query: () => {
        return {
          url: `/myGarage/Seller/myOrders`,
          method: "GET"
        }
      }
    })
  }),
});

export const {
  useLazyGetMyOrdersVehiclesQuery,
  useLazyGetSellerMyOrdersVehiclesQuery
} = myOrdersApi;
